/**
 * Asynchronously loads the component for PiecripLoginPage
 */

import { lazyLoad } from '@utils/loadable';

export const PiecripLoginPage = lazyLoad(
  () => import('./index'),
  (module) => module.PiecripLoginPage,
);
